import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import ServiceEditHeader from '../../components/services/edit/ServiceEditHeader'
import { getService } from '../../state/reducers/services'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  const serviceId = state.service.metadata.edit.serviceId
  let service
  if (serviceId) {
    service = getService(state, serviceId)
  }
  return {
    serviceId,
    name: service ? service.name : '',
    program: service && service.serviceProgram ? state.serviceProgram[service.serviceProgram] : undefined
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceEditHeader)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceEditHeader.ts